export const getClearanceLevelInt = (userCurrentClearanceLevel) => {
  const raw = userCurrentClearanceLevel?.Level;
  const parsed = parseInt(raw, 10);
  return Number.isNaN(parsed) ? null : parsed;
};
